import {useState} from "react";
import {Link} from "react-router-dom";

const dgisIcon = `${process.env.PUBLIC_URL}/assets/2gis.png`;
const staffIcon = `${process.env.PUBLIC_URL}/assets/Staff.png`;
const termsIcon = `${process.env.PUBLIC_URL}/assets/Terms.png`;
const pricesIcon = `${process.env.PUBLIC_URL}/assets/Prices.png`;

const infoButtons = [
    {
        href: "/address",
        icon: dgisIcon,
        alt: "Адрес",
        text: "Адрес",
        className: "dgis-badge",
    },
    {
        href: "/staff",
        icon: staffIcon,
        alt: "Персонал",
        text: "Персонал",
    },
    {
        href: "/terms",
        icon: termsIcon,
        alt: "Сроки",
        text: "Сроки",
    },
    {
        href: "/prices",
        icon: pricesIcon,
        alt: "Цены",
        text: "Цены",
    },
];

function Info() {
    const [isDismissed, setIsDismissed] = useState(false);

    function handleInfoButtonClick() {
        setIsDismissed(true);
    }

    return (
        <div
            className="action-buttons"
            data-dismissed={isDismissed ? "true" : "false"}
            onMouseLeave={() => setIsDismissed(false)}
        >
            <button
                className="info-toggle"
                type="button"
                aria-controls="info-menu"
            >
                <span>Информация</span>
                <span className="info-toggle-arrow" aria-hidden="true"/>
            </button>

            <div className="info-list" id="info-menu" role="group" aria-label="Информация">
                {infoButtons.map((button) => {
                    const className = `info-btn ${button.className || ""}`.trim();
                    const content = (
                        <>
                            <span className="btn-icon" aria-hidden="true">
                                <img src={button.icon} alt={button.alt}/>
                            </span>
                            <span className="btn-text">{button.text}</span>
                        </>
                    );

                    if (button.isExternal) {
                        return (
                            <a
                                className={className}
                                href={button.href}
                                key={button.text}
                                rel="noopener noreferrer"
                                target="_blank"
                                onClick={handleInfoButtonClick}
                            >
                                {content}
                            </a>
                        );
                    }

                    return (
                        <Link
                            className={className}
                            key={button.text}
                            to={button.href}
                            onClick={handleInfoButtonClick}
                        >
                            {content}
                        </Link>
                    );
                })}
            </div>
        </div>
    )
}

export default Info;
